import Route from '@ember/routing/route';

export default class CoachingRoute extends Route {}
